export default __webpack_public_path__ + "static/media/cover-photo.7cae2155.png";